<template>
  <div v-if="user" class="sidebar-user-profile">
    <div class="sidebar-user-avatar">
      {{ initials }}
    </div>
    <div class="sidebar-user-name">{{ displayName }}</div>
    <div class="sidebar-user-email">{{ user.email }}</div>
  </div>
</template>

<script>
export default {
  name: 'SidebarUserProfile',
  data() {
    return {
      user: null,
    };
  },
  computed: {
    initials() {
      if (!this.user?.email) return '?';
      const part = this.user.email.split('@')[0];
      const segments = part.split(/[._-]/).filter(Boolean);
      if (segments.length >= 2) {
        return (segments[0][0] + segments[1][0]).toUpperCase();
      }
      return part.slice(0, 2).toUpperCase();
    },
    displayName() {
      if (!this.user?.email) return 'Usuario';
      if (this.user.name) return this.user.name;
      const part = this.user.email.split('@')[0];
      const segments = part.split(/[._-]/).filter(Boolean);
      if (segments.length >= 2) {
        return segments
          .map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
          .join(' ');
      }
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    },
  },
  mounted() {
    this.loadUser();
  },
  methods: {
    loadUser() {
      try {
        const stored = localStorage.getItem('user');
        if (stored) {
          this.user = JSON.parse(stored);
        }
      } catch {
        this.user = null;
      }
    },
  },
};
</script>
